(ns ncr.fragment.folder
  (:require
   [cljs.core.async :as async :refer-macros [go]]
   [clojure.core.match :refer [match]]
   [lambdaisland.glogi :as log]
   [uix.core.alpha :as uix]
   [taoensso.encore :as e]
   [ncr.me :as me]
   [ncr.widgets.pf :as wpf]
   [ncr.etc.pf :as pf]
   [ncr.etc.util :as u]
   [ncr.etc.pubsub :as ps]
   [ncr.etc.rhf :as rhf]
   [ncr.etc.modal :as m]
   [ncr.etc.alert :as a]
   [ncr.backend :as b]
   [ncr.nsql :as nsql]))

(defn c-folder-selector [id {:keys [control]} control-name folders-by-id]
  (let
    [folders
     (->> (vals folders-by-id)
       (sort-by :name))]

    [rhf/c-controller
     {:name control-name
      :control control
      :rules
      {:required true}
      :render
      (fn [props]
        [wpf/c-pf-select
         {:toggle-id id
          :variant :typeahead
          :max-height "200px"
          :class :ncr-input-folder-selector
          :position :right
          :label-fn :name

          :selections
          (get folders-by-id (get-in props [:field :value]))
          :on-select
          (fn [_ {:keys [id]} _]
            ((-> props :field :on-change) id))}
         folders])}]))

(defn- c-move-dialog [me fragments]
  (let
    [singleton (u/singleton fragments)
     ref (uix/ref)
     modal-id :edit-fragment-folder-modal

     by-id
     (u/index-by :id
       (conj
         (me/shared-folders me)
         (me/inbox-folder me)))

     {:keys [submit] :as form}
     (rhf/use-form
       {:should-focus-error false
        :default-values
        {:folder
         (when (some? singleton)
           (let [folder (get singleton :folder)]
             (when (contains? by-id folder)
               folder)))}})]

    (m/use-submit-form modal-id ref submit)

    [m/c-modal
     {:title
      (if (some? singleton)
        "Move Fragment to"
        (u/format "Move %d Fragments to" (count fragments)))
      :variant :medium
      :id modal-id
      :ref ref
      :is-overflow-visible true
      :actions
      [[pf/c-button
        {:variant :primary
         :on-click submit}
        "Ok"]
       [pf/c-button
        {:variant :link :on-click #(m/close! nil)} "Cancel"]]}
     [pf/c-form {:on-submit submit}
      (let [id (uix/memo #(gensym) [])]
        [rhf/c-form-group {:label "Folder" :field-id id} :folder form
         [c-folder-selector id form :folder by-id]])]]))

(defn- !move-to [me fragments folder]
  (let
    [{folder-name :name} (me/folder-by-id me folder)]
    (a/!fragment-operation
      {:operation-title
       (u/format "Moving to folder %s" folder-name)
       :success-title (u/format "Moved to folder %s" folder-name)
       :fragments fragments}

      (b/!multi-mutation
        (map
          (fn [{:keys [id]}]
            [(keyword id)
             [:reference_move
              {:id id :folder folder}]])
          fragments)))))

(defn !move-to-trash [me fragments]
  (let [{:keys [id]} (me/trash-folder me)]
    (go
      (when (<! (!move-to me fragments id))
        (ps/pub! [:me/load])))))

(defn !move [me fragments]
  (go
    (if-let [{:keys [folder]} (<! (m/!modal #'c-move-dialog me fragments))]
      (when (<! (!move-to me fragments folder))
        (ps/pub! [:me/load]))
      [:error :cancel])))

(defn !empty-trash []
  (go
    (when
      (<!
        (m/!alert
          {:title "Empty Trash"
           :title-icon-variant :warning
           :actions-variant :ok-cancel
           :body
           [:span "Are you sure, you want to empty trash?"]}))

      (<!
        (a/!operation
          {:operation-title "Empty Trash"
           :success-title "Trash is now empty!"}
          (b/!mutation
            [:reference_empty_trash])))
      true)))

(defn query->folder-id [folders query]
  (when-some [folder-name (some-> query nsql/analyze-simple :in)]
    (some
      (fn [{:keys [name id]}]
        (when (= name folder-name)
          id))
      folders)))
